// One-click themes. `primary_color` drives the navy ramp; `tokens` are the --token-* colours.
// Each theme sets its own status colours so they sit with the palette instead
// of clashing with it (a green theme needs a success green that still reads as
// "success", a red theme needs an error red that isn't its own button colour).
import { BRANDING_DEFAULTS, THEME_TOKEN_DEFAULTS } from '../../context/BrandingContext'

// Brand colour doubles as the sidebar background and the "on" toggle, as in the default theme.
const preset = ({ id, name, brand, primary, hover, active, success, warning, error, info }) => ({
  id,
  name,
  builtIn: true,
  primary_color: brand,
  tokens: {
    ...THEME_TOKEN_DEFAULTS,
    primary,
    primary_hover: hover,
    primary_active: active,
    background: brand,
    toggle_on: brand,
    success,
    warning,
    error,
    info,
  },
})

export const THEME_PRESETS = [
  {
    id: 'xtract',
    name: 'Xtract',
    builtIn: true,
    primary_color: BRANDING_DEFAULTS.primary_color,
    swatches: ['#1e2a3b', '#334e68', '#3b9b5e', '#D9C800', '#d94a44', '#F7F8FA'],
    tokens: { ...THEME_TOKEN_DEFAULTS },
  },
  preset({
    id: 'ocean_blue', name: 'Ocean Blue',
    brand: '#0b2545', primary: '#1d4ed8', hover: '#1e40af', active: '#1e3a8a',
    success: '#059669', warning: '#d97706', error: '#dc2626', info: '#0891b2',
  }),
  preset({
    id: 'deep_teal', name: 'Deep Teal',
    brand: '#0f3a40', primary: '#0f766e', hover: '#115e59', active: '#134e4a',
    success: '#16a34a', warning: '#d97706', error: '#dc2626', info: '#0369a1',
  }),
  preset({
    id: 'evergreen', name: 'Evergreen',
    brand: '#173d2c', primary: '#2f6b4f', hover: '#265a42', active: '#1d4735',
    success: '#4d8f1f', warning: '#b7791f', error: '#c53030', info: '#2b6cb0',
  }),
  preset({
    id: 'royal_indigo', name: 'Royal Indigo',
    brand: '#1e1b4b', primary: '#4f46e5', hover: '#4338ca', active: '#3730a3',
    success: '#059669', warning: '#d97706', error: '#e11d48', info: '#0284c7',
  }),
  preset({
    id: 'slate_grey', name: 'Slate Grey',
    brand: '#1f2937', primary: '#374151', hover: '#1f2937', active: '#111827',
    success: '#16a34a', warning: '#ca8a04', error: '#dc2626', info: '#2563eb',
  }),
  preset({
    id: 'burgundy', name: 'Burgundy',
    brand: '#3b0d1c', primary: '#9f1239', hover: '#881337', active: '#6b0f2a',
    success: '#15803d', warning: '#ca8a04', error: '#dc2626', info: '#1d4ed8',
  }),
  preset({
    id: 'copper', name: 'Copper',
    brand: '#3a2618', primary: '#b45309', hover: '#92400e', active: '#78350f',
    success: '#15803d', warning: '#ca8a04', error: '#dc2626', info: '#0369a1',
  }),
]
